import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { DELETE_SENDERS } from '../../../mutation/mutation';

class DeleteSenders extends Component {
  constructor(props) {
    super(props);

    this.deleteSenders = this.deleteSenders.bind(this);
  }

  deleteSenders() {
    const confirm = window.confirm('⚠️ Are you sure to delete senders (except the admin) ?');
    if (!confirm) {
      return;
    }

    this.props.client.mutate({
      mutation: DELETE_SENDERS,
      variables: {
        boxId: this.props.boxId,
      },
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  render() {
    return (
      <Button
        type="submit"
        color="danger"
        onClick={this.deleteSenders}>
      Delete senders (except the admin)
      </Button>
    );
  }
}

export default withApollo(DeleteSenders);



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/infos/delete-senders.js